
<app-hr-page-header
  [heading]="headingHoliday"
  [searchPlaceholder]="'Search holidays'"
  [addButtonText]="'Add Holiday'"
  [exportButtonText]="'Export'"
  [initialSearchQuery]="searchQuery"
  [showFilterIcon]="false"
  (searchInput)="onSearchInput($event)"
  (addClick)="addHoliday()"
  (exportClick)="exportHolidays()"
  (filterClick)="openFilterDialog()"
></app-hr-page-header>



<div class="col col-holiday-filter">
  <div class="radio-group">
    <div class="radio-option">
      <input 
        type="radio" 
        id="all" 
        name="holidayFilter" 
        value="all" 
        [(ngModel)]="selectedButton"
        (change)="onButtonClick('all')"
      />
      <label for="all">All</label>
    </div>
    <div class="radio-option">
      <input 
        type="radio" 
        id="upcoming" 
        name="holidayFilter" 
        value="upcoming" 
        [(ngModel)]="selectedButton"
        (change)="onButtonClick('upcoming')"
      />
      <label for="upcoming">Upcoming</label>
    </div>
    <div class="radio-option">
      <input 
        type="radio" 
        id="past" 
        name="holidayFilter" 
        value="past" 
        [(ngModel)]="selectedButton"
        (change)="onButtonClick('past')"
      />
      <label for="past">Past</label>
    </div>
  </div>
</div>
<!-- <app-hr-page-header
  [heading]="headingHoliday"
  [searchPlaceholder]="'Search holidays'"
  [addButtonText]="'Add Holiday'"
  [exportButtonText]="'Export'"
  [showAddButton]="true"
  (addClick)="openAddHolidayDialog()"
  (exportClick)="exportHolidays()"
></app-hr-page-header> -->

<div class="hr-table-container">
  <div class="table-responsive">
    <table class="table" id="emp_expense">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Type</th>
          <th>Day</th>
          <th>Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let holiday of filteredHolidayData
              | paginate : { itemsPerPage: 10, currentPage: p };
            let i = index
          "
        >
          <td>{{ i + 1 }}</td>
          <td>{{ holiday.title | titlecase }}</td>
          <td>{{ holiday.type | titlecase }}</td>
          <td>{{ getDayForDate(holiday.date) }}</td>
          <td>{{ holiday.date }}</td>
          <td>
            <button
              (click)=" openDeleteConfirmation(holiday.id)"
              class="btn btn-danger"
            >
              Delete
              <!-- <i class="fa fa-trash" aria-hidden="true"></i> -->
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="page_div">
  <div class="row" id="pagination-container">
    <pagination-controls (pageChange)="p = $event"></pagination-controls>
  </div>
</div>
